exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".PaymentSuccess-ecd5287e{width:420px;height:269px;background-color:#fff;border-radius:2px;color:#2A2A2A;font-size:15px;line-height:22px;font-weight:400}.withPadding-6ef0c817{padding:30px 156px 6px 156px}.line-1d597f7c{box-sizing:border-box;height:2px;width:100%;border:1px solid #BDBDBD;margin-bottom:29px}.next-f285596a{margin:29px 50px 30px 50px}.toProfile-07cb29c8{margin:0 50px 40px 50px}\n", ""]);

// Exports
exports.locals = {
	"PaymentSuccess": "PaymentSuccess-ecd5287e",
	"withPadding": "withPadding-6ef0c817",
	"line": "line-1d597f7c",
	"next": "next-f285596a",
	"toProfile": "toProfile-07cb29c8"
};